export const PermissionType = {
  PROCESS: 'PROCESS',
  FINANCIAL_PANEL: 'FINANCIAL_PANEL',
  INVESTMENT: 'INVESTMENT',
  REPORT: 'REPORT',
  NOT_CLASSIFIED: 'NOT_CLASSIFIED',
  DEPARTMENT: 'DEPARTMENT',
  GROUP: 'GROUP',
  POSITION: 'POSITION',
  PERMISSIONS: 'PERMISSIONS',
  STATUS: 'STATUS',
  USERS: 'USERS',
};

const {
  PROCESS,
  FINANCIAL_PANEL,
  REPORT,
  INVESTMENT,
  DEPARTMENT,
  GROUP,
  POSITION,
  PERMISSIONS,
  STATUS,
  USERS,
} = PermissionType;

const Presets = {
  ASESOR_PRESET: 'ASESOR',
  MANAGER_PRESET: 'MANAGER',
  DIRECTOR_PRESET: 'DIRECTOR',
  SUBDIRECTOR_PRESET: 'SUBDIRECTOR',
  COMPLIANCE_PRESET: 'COMPLIANCE',
};

const {
  ASESOR_PRESET,
  MANAGER_PRESET,
  DIRECTOR_PRESET,
  SUBDIRECTOR_PRESET,
  COMPLIANCE_PRESET,
} = Presets;

const Permissions = {
  CAN_READ_PROFILES: {
    value: 'can_read_profiles',
    text: 'Puede ver usuarios',
    presets: [],
    group: USERS,
    order: 1,
  },
  CAN_CREATE_PROFILES: {
    value: 'can_create_profiles',
    text: 'Puede crear usuarios',
    presets: [],
    group: USERS,
    order: 2,
  },
  CAN_EDIT_PROFILES: {
    value: 'can_edit_profiles',
    text: 'Puede editar usuarios',
    presets: [],
    group: USERS,
    order: 3,
  },
  CAN_DELETE_PROFILES: {
    value: 'can_delete_profiles',
    text: 'Puede eliminar usuarios',
    presets: [],
    group: USERS,
    order: 4,
  },
  CAN_ASSIGN_PROFILES_PERMISSIONS: {
    value: 'can_assign_profiles_permissions',
    text: 'Puede agregar permisos a los usuarios',
    presets: [],
    group: USERS,
    order: 5,
  },
  CAN_READ_BROKERS: {
    value: 'can_read_brokers',
    text: 'Puede ver agentes',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
    ],
    group: PROCESS,
    order: 0,
  },
  CAN_READ_LOAN_APPLICATIONS_IN_GENERAL: {
    value: 'can_read_loan_applications_in_general',
    text: 'Puede ser solicitudes en General',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 0,
  },
  CAN_READ_LOAN_APPLICATIONS_IN_VALIDATION: {
    value: 'can_read_loan_applications_in_validation',
    text: 'Puede ver solicitudes en Validación',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 1,
  },
  CAN_READ_HOME_LOAN_APPLICATIONS: {
    value: 'can_read_home_loan_applications',
    text: 'Puede ver solicitudes Hogar',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 2,
  },
  CAN_READ_SOLUTION_LOAN_APPLICATIONS: {
    value: 'can_read_solution_loan_applications',
    text: 'Puede ver solicitudes Solución',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 3,
  },
  CAN_READ_PERSONAL_LOAN_APPLICATIONS: {
    value: 'can_read_personal_loan_applications',
    text: 'Puede ver solicitudes Personales',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 4,
  },
  CAN_READ_NOT_CLASSIFIED_APPLICATIONS: {
    value: 'can_read_not_classified_applications',
    text: 'Puede ver solicitudes No Clasificadas',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 6,
  },
  CAN_READ_OWN_LOAN_APPLICATIONS: {
    value: 'can_read_own_loan_applications',
    text: 'Puede ver solicitudes Propias',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 7,
  },
  CAN_READ_DOES_NOT_HAVE_HOME_LOAN_APPLICATIONS: {
    value: 'can_read_does_not_have_home_loan_applications',
    text: 'Puede ver solicitudes No Tiene Vivienda',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 8,
  },
  CAN_READ_VEHICLE_LOAN_APPLICATIONS: {
    value: 'can_read_vehicle_loan_applications',
    text: 'Puede ver solicitudes Vehicular',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 9,
  },
  CAN_READ_OTHERS_LOAN_APPLICATIONS: {
    value: 'can_read_others_loan_applications',
    text: 'Ver solicitudes Ajenas',
    presets: [
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 8,
  },
  CAN_READ_LOANS: {
    value: 'can_read_loans',
    text: 'Puede ver préstamos',
    presets: [COMPLIANCE_PRESET],
    group: PROCESS,
    order: 10,
  },
  CAN_READ_LEGAL_LOANS: {
    value: 'can_read_legal_loans',
    text: 'Puede ver préstamos legales',
    presets: [COMPLIANCE_PRESET],
    group: PROCESS,
    order: 11,
  },
  CAN_CREATE_LOANS: {
    value: 'can_create_loans',
    text: 'Puede crear prestamos',
    presets: [COMPLIANCE_PRESET],
    group: PROCESS,
    order: 12,
  },
  CAN_CREATE_PAYMENTS: {
    value: 'can_create_payments',
    text: 'Puede hacer pagos',
    presets: [],
    group: PROCESS,
    order: 13,
  },
  CAN_APPLY_DISCOUNT: {
    value: 'can_apply_discount',
    text: 'Puede aplicar descuentos',
    presets: [],
    group: PROCESS,
    order: 14,
  },
  CAN_EDIT_LOAN_APPLICATION: {
    value: 'can_edit_loan_application',
    text: 'Puede editar solicitudes',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 15,
  },
  CAN_ARCHIVE_LOAN_APPLICATION: {
    value: 'can_archive_loan_application',
    text: 'Puede archivar solicitudes',
    presets: [],
    group: PROCESS,
    order: 16,
  },
  CAN_CREATE_LOAN_APPLICATION_NOTE: {
    value: 'can_create_loan_application_note',
    text: 'Puede crear notas',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 17,
  },
  CAN_READ_LOAN_APPLICATION_NOTES: {
    value: 'can_read_loan_application_notes',
    text: 'Puede ver notas',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 18,
  },
  CAN_EDIT_RATING: {
    value: 'can_edit_rating',
    text: 'Puede editar rating',
    presets: [COMPLIANCE_PRESET],
    group: PROCESS,
    order: 19,
  },
  CAN_READ_KYC_AND_AML: {
    value: 'can_read_kyc_and_aml',
    text: 'Puede ver Kyc y Aml',
    presets: [],
    group: PROCESS,
    order: 20,
  },
  CAN_READ_PYMES_SOLUTION_LOAN_APPLICATIONS: {
    value: 'can_read_pymes_solution_loan_applications',
    text: 'Ver solicitudes Solución Empresa',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 21,
  },
  CAN_READ_BUILDING_LOAN_APPLICATIONS: {
    value: 'can_read_building_loan_applications',
    text: 'Ver solicitudes Construcción',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 22,
  },
  CAN_READ_COMMERCIAL_LOAN_APPLICATIONS: {
    value: 'can_read_commercial_loan_applications',
    text: 'Ver solicitudes Comerciales',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 23,
  },
  CAN_CREATE_CONTRACT: {
    value: 'can_create_contract',
    text: 'Puede crear contratos',
    presets: [COMPLIANCE_PRESET],
    group: REPORT,
    order: 0,
  },
  CAN_CREATE_PROMISSORY_NOTE: {
    value: 'can_create_promissory_note',
    text: 'Puede crear pagaré notarial',
    presets: [COMPLIANCE_PRESET],
    group: REPORT,
    order: 1,
  },
  CAN_READ_MOVEMENTS: {
    value: 'can_read_movements',
    text: 'Puede ver movimientos',
    presets: [],
    group: FINANCIAL_PANEL,
    order: 0,
  },
  CAN_READ_MOVEMENTS_SUMMARY: {
    value: 'can_read_movements_summary',
    text: 'Puede ver resumen de movimientos',
    presets: [],
    group: FINANCIAL_PANEL,
    order: 1,
  },
  CAN_READ_BANK_ACCOUNTS: {
    value: 'can_read_bank_accounts',
    text: 'Puede ver cuentas bancarias',
    presets: [],
    group: FINANCIAL_PANEL,
    order: 2,
  },
  CAN_UPDATE_BANK_ACCOUNT_BALANCE: {
    value: 'can_update_bank_account_balance',
    text: 'Puede actualizar balance de cuenta bancaria',
    presets: [],
    group: FINANCIAL_PANEL,
    order: 3,
  },
  CAN_READ_DEPARTMENTS: {
    value: 'can_read_departments',
    text: 'Puede ver departamentos',
    presets: [],
    group: DEPARTMENT,
    order: 0,
  },
  CAN_CREATE_DEPARTMENTS: {
    value: 'can_create_departments',
    text: 'Puede crear departamentos',
    presets: [],
    group: DEPARTMENT,
    order: 1,
  },
  CAN_EDIT_DEPARTMENTS: {
    value: 'can_edit_departments',
    text: 'Puede editar departamentos',
    presets: [],
    group: DEPARTMENT,
    order: 2,
  },
  CAN_DELETE_DEPARTMENTS: {
    value: 'can_delete_departments',
    text: 'Puede eliminar departamentos',
    presets: [],
    group: DEPARTMENT,
    order: 3,
  },
  CAN_READ_GROUPS: {
    value: 'can_read_groups',
    text: 'Puede ver grupos',
    presets: [],
    group: GROUP,
    order: 0,
  },
  CAN_CREATE_GROUPS: {
    value: 'can_create_groups',
    text: 'Puede crear grupos',
    presets: [],
    group: GROUP,
    order: 1,
  },
  CAN_EDIT_GROUPS: {
    value: 'can_edit_groups',
    text: 'Puede editar grupos',
    presets: [],
    group: GROUP,
    order: 2,
  },
  CAN_DELETE_GROUPS: {
    value: 'can_delete_groups',
    text: 'Puede eliminar grupos',
    presets: [],
    group: GROUP,
    order: 3,
  },
  CAN_READ_POSITIONS: {
    value: 'can_read_positions',
    text: 'Puede ver posiciones',
    presets: [],
    group: POSITION,
    order: 0,
  },
  CAN_CREATE_POSITIONS: {
    value: 'can_create_positions',
    text: 'Puede crear posiciones',
    presets: [],
    group: POSITION,
    order: 1,
  },
  CAN_EDIT_POSITIONS: {
    value: 'can_edit_positions',
    text: 'Puede editar posiciones',
    presets: [],
    group: POSITION,
    order: 2,
  },
  CAN_DELETE_POSITIONS: {
    value: 'can_delete_positions',
    text: 'Puede eliminar posiciones',
    presets: [],
    group: POSITION,
    order: 3,
  },
  CAN_GRANT_PERMISSIONS: {
    value: 'can_grant_permissions',
    text: 'Puede otorgar permisos',
    presets: [],
    group: PERMISSIONS,
    order: 1,
  },
  CAN_REVOKE_PERMISSIONS: {
    value: 'can_revoke_permissions',
    text: 'Puede revocar permisos',
    presets: [],
    group: PERMISSIONS,
    order: 2,
  },
  CAN_CREATE_PERMISSIONS: {
    value: 'can_create_permissions',
    text: 'Puede crear permisos',
    presets: [],
    group: PERMISSIONS,
    order: 3,
  },
  CAN_READ_PERMISSIONS: {
    value: 'can_read_permissions',
    text: 'Puede ver permisos',
    presets: [],
    group: PERMISSIONS,
    order: 4,
  },
  CAN_EDIT_PERMISSIONS: {
    value: 'can_edit_permissions',
    text: 'Puede editar permisos',
    presets: [],
    group: PERMISSIONS,
    order: 5,
  },
  CAN_DELETE_PERMISSIONS: {
    value: 'can_delete_permissions',
    text: 'Puede eliminar permisos',
    presets: [],
    group: PERMISSIONS,
    order: 6,
  },
  CAN_READ_PRODUCTS: {
    value: 'can_read_products',
    text: 'Puede ver productos iBAN Wallet',
    presets: [],
    group: INVESTMENT,
  },
  CAN_CREATE_PRODUCTS: {
    value: 'can_create_products',
    text: 'Puede crear productos iBAN Wallet',
    presets: [],
    group: INVESTMENT,
  },
  CAN_READ_WALLET_USERS: {
    value: 'can_read_wallet_users',
    text: 'Puede ver usuarios iBAN Wallet',
    presets: [],
    group: INVESTMENT,
  },
  CAN_EDIT_WALLET_USERS: {
    value: 'can_edit_wallet_users',
    text: 'Puede editar usuarios iBAN Wallet',
    presets: [],
    group: INVESTMENT,
  },
  CAN_READ_USER_PRODUCTS: {
    value: 'can_read_user_products',
    text: 'Puede leer productos de usuarios iBAN Wallet',
    presets: [],
    group: INVESTMENT,
  },
  CAN_CREATE_USER_PRODUCTS: {
    value: 'can_create_user_products',
    text: 'Puede crear productos a usuarios iBAN Wallet',
    presets: [],
    group: INVESTMENT,
  },
  CAN_UPDATE_LOAN_APPLICATION_REFERENCE_CODE: {
    value: 'can_update_loan_application_reference_code',
    text: 'Puede editar código referencia en formulario',
    presets: [],
    group: PROCESS,
  },
  CAN_UPDATE_LOAN_APPLICATION_ANALYST_CODE: {
    value: 'can_update_loan_application_analyst_code',
    text: 'Puede editar código analista de riesgo en formulario',
    presets: [],
    group: PROCESS,
  },
  CAN_READ_BUTTON_CIEC_FORM: {
    value: 'can_read_button_ciec_form',
    text: 'Puede ver el botón de envió de formulario CIEC',
    presets: [],
    group: PROCESS,
  },
  CAN_EDIT_TERMS_AND_CONDITIONS_OF_USE: {
    value: 'can_edit_terms_and_conditions_of_use',
    text: 'Can update ibanwallet.com terms and conditions of use with GraphCMS',
    presets: [],
    group: PROCESS,
  },
  CAN_UPDATE_LOAN_APPLICATION_STATUS_VALIDATION: {
    value: 'can_update_loan_application_status_validation',
    text: 'Puede editar el estado de la solicitud en validación',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
  },
  CAN_UPDATE_LOAN_APPLICATION_STATUS_GENERAL: {
    value: 'can_update_loan_application_status_general',
    text: 'Puede editar el estado de la solicitud en general',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
  },
  CAN_READ_MORTGAGE_APPLICATIONS: {
    value: 'can_read_mortgage_applications',
    text: 'Puede ver solicitudes de Mejora tu Hipoteca',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
  },
  CAN_UPDATE_NO_CONTACT_STATUS: {
    value: 'can_update_no_contact_status',
    text: 'Puede actualizar el estado Sin Contactar',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
    ],
    group: STATUS,
    order: 1,
  },
  CAN_UPDATE_TRY_RECALL_STATUS: {
    value: 'can_update_try_recall_status',
    text: 'Puede actualizar el estado Volver a Llamar',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
    ],
    group: STATUS,
    order: 2,
  },
  CAN_UPDATE_MISTAKEN_STATUS: {
    value: 'can_update_mistaken_status',
    text: 'Puede actualizar el estado Equivocado',
    presets: [],
    group: STATUS,
    order: 3,
  },
  CAN_UPDATE_DOES_NOT_HAVE_STATUS: {
    value: 'can_update_does_not_have_status',
    text: 'Puede actualizar el estado No Tiene',
    presets: [],
    group: STATUS,
    order: 4,
  },
  CAN_UPDATE_DOES_NOT_WANT_STATUS: {
    value: 'can_update_does_not_want_status',
    text: 'Puede actualizar el estado No Quiere',
    presets: [],
    group: STATUS,
    order: 5,
  },
  CAN_UPDATE_DOES_NOT_APPLY_STATUS: {
    value: 'can_update_does_not_apply_status',
    text: 'Puede actualizar el estado No Aplica',
    presets: [],
    group: STATUS,
    order: 6,
  },
  CAN_UPDATE_UNABLE_TO_REACH_STATUS: {
    value: 'can_update_unable_to_reach_status',
    text: 'Puede actualizar el estado No Pude Comunicarme',
    presets: [COMPLIANCE_PRESET],
    group: STATUS,
    order: 7,
  },
  CAN_UPDATE_PENDING_RECEIVE_DOC_STATUS: {
    value: 'can_update_pending_receive_doc_status',
    text: 'Puede actualizar el estado Pendiente Recibir Documentación',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
    ],
    group: STATUS,
    order: 8,
  },
  CAN_UPDATE_RECEIVE_DOC_STATUS: {
    value: 'can_update_receive_doc_status',
    text: 'Puede actualizar el estado Recibir Documentación',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
    ],
    group: STATUS,
    order: 9,
  },
  CAN_UPDATE_PENDING_ANALYSIS_STATUS: {
    value: 'can_update_pending_analysis_status',
    text: 'Puede actualizar el estado Pendiente de Análisis',
    presets: [COMPLIANCE_PRESET],
    group: STATUS,
    order: 10,
  },
  CAN_UPDATE_CREDIT_ANALYSIS_STATUS: {
    value: 'can_update_credit_analysis_status',
    text: 'Puede actualizar el estado Análisis de Crédito',
    presets: [COMPLIANCE_PRESET],
    group: STATUS,
    order: 11,
  },
  CAN_UPDATE_CREDIT_APPROVED_STATUS: {
    value: 'can_update_credit_approved_status',
    text: 'Puede actualizar el estado Aprobado por Crédito',
    presets: [COMPLIANCE_PRESET],
    group: STATUS,
    order: 12,
  },
  CAN_UPDATE_COMPLIANCE_REVIEW_STATUS: {
    value: 'can_update_compliance_review_status',
    text: 'Puede actualizar el estado Revisión Cumplimiento',
    presets: [COMPLIANCE_PRESET],
    group: STATUS,
    order: 12.1,
  },
  CAN_UPDATE_COMPLIANCE_APPROVED_STATUS: {
    value: 'can_update_compliance_approved_status',
    text: 'Puede actualizar el estado Aprobado Cumplimiento',
    presets: [COMPLIANCE_PRESET],
    group: STATUS,
    order: 12.2,
  },
  CAN_UPDATE_FORMALIZATION_REVIEW_STATUS: {
    value: 'can_update_formalization_review_status',
    text: 'Puede actualizar el estado Revisión Formalización',
    presets: [],
    group: STATUS,
    order: 12.3,
  },
  CAN_UPDATE_FORMALIZATION_APPROVED_STATUS: {
    value: 'can_update_formalization_approved_status',
    text: 'Puede actualizar el estado Aprobado Formalización',
    presets: [],
    group: STATUS,
    order: 12.4,
  },
  CAN_UPDATE_APPROVED_STATUS: {
    value: 'can_update_approved_status',
    text: 'Puede actualizar el estado Crédito Aprobado',
    presets: [],
    group: STATUS,
    order: 13,
  },
  CAN_UPDATE_LEGAL_AND_INSURANCE_STATUS: {
    value: 'can_update_legal_and_insurance_status',
    text: 'Puede actualizar el estado Legal y Seguro',
    presets: [],
    group: STATUS,
    order: 14,
  },
  CAN_UPDATE_PENDING_SIGNATURE_STATUS: {
    value: 'can_update_pending_signature_status',
    text: 'Puede actualizar el estado Pendiente de Firma',
    presets: [],
    group: STATUS,
    order: 15,
  },
  CAN_UPDATE_SIGNED_STATUS: {
    value: 'can_update_signed_status',
    text: 'Puede actualizar el estado Firmado',
    presets: [],
    group: STATUS,
    order: 16,
  },
  CAN_UPDATE_PENDING_TO_GENERATE_LOAN_STATUS: {
    value: 'can_update_pending_to_generate_loan_status',
    text: 'Puede actualizar el estado Pendiente de Generar Préstamo',
    presets: [],
    group: STATUS,
    order: 17,
  },
  CAN_UPDATE_GENERATED_LOAN_STATUS: {
    value: 'can_update_generated_loan_status',
    text: 'Puede actualizar el estado Préstamo Generado',
    presets: [],
    group: STATUS,
    order: 18,
  },
  CAN_UPDATE_DISBURSED_STATUS: {
    value: 'can_update_disbursed_status',
    text: 'Puede actualizar el estado Desembolsado',
    presets: [],
    group: STATUS,
    order: 19,
  },
  CAN_UPDATE_PAY_OFF_STATUS: {
    value: 'can_update_pay_off_status',
    text: 'Puede actualizar el estado Crédito Saldado',
    presets: [],
    group: STATUS,
    order: 20,
  },
  CAN_UPDATE_PENDING_STATUS: {
    value: 'can_update_pending_status',
    text: 'Puede actualizar el estado Pendiente',
    presets: [],
    group: STATUS,
    order: 21,
  },
  CAN_UPDATE_REJECTED_STATUS: {
    value: 'can_update_rejected_status',
    text: 'Puede actualizar el estado Rechazado',
    presets: [],
    group: STATUS,
    order: 22,
  },
  CAN_UPDATE_CANCELED_STATUS: {
    value: 'can_update_canceled_status',
    text: 'Puede actualizar el estado Cancelado',
    presets: [],
    group: STATUS,
    order: 23,
  },
  CAN_BE_ASSIGNED_LOAN_APPLICATIONS_AUTOMATICALLY_WEB_DO: {
    value: 'can_be_assigned_loan_applications_automatically_web_do',
    text: 'Puede recibir solicitudes automáticamente de la pagina web de RD',
    presets: [],
    group: PROCESS,
    order: 20,
  },
  CAN_BE_ASSIGNED_LOAN_APPLICATIONS_AUTOMATICALLY_WEB_MX: {
    value: 'can_be_assigned_loan_applications_automatically_web_mx',
    text: 'Puede recibir solicitudes automáticamente de la pagina web de MX',
    presets: [],
    group: PROCESS,
    order: 21,
  },
  CAN_BE_ASSIGNED_LOAN_APPLICATIONS_AUTOMATICALLY_WEB_CO: {
    value: 'can_be_assigned_loan_applications_automatically_web_co',
    text: 'Puede recibir solicitudes automáticamente de la pagina web de CO',
    presets: [],
    group: PROCESS,
    order: 22,
  },
  CAN_BE_ASSIGNED_LOAN_APPLICATIONS_AUTOMATICALLY_RRSS_DO: {
    value: 'can_be_assigned_loan_applications_automatically_rrss_do',
    text: 'Puede recibir solicitudes automáticamente de la red social DO',
    presets: [],
    group: PROCESS,
    order: 23,
  },
  CAN_BE_ASSIGNED_LOAN_APPLICATIONS_AUTOMATICALLY_RRSS_CO: {
    value: 'can_be_assigned_loan_applications_automatically_rrss_co',
    text: 'Puede recibir solicitudes automáticamente de la red social CO',
    presets: [],
    group: PROCESS,
    order: 24,
  },
  CAN_BE_ASSIGNED_LOAN_APPLICATIONS_AUTOMATICALLY_RRSS_MX: {
    value: 'can_be_assigned_loan_applications_automatically_rrss_mx',
    text: 'Puede recibir solicitudes automáticamente de la red social MX',
    presets: [],
    group: PROCESS,
    order: 25,
  },
  CAN_BE_ASSIGNED_LOAN_APPLICATIONS_AUTOMATICALLY_CLIENT_AREA_DO: {
    value: 'can_be_assigned_loan_applications_automatically_client_area_do',
    text:
      'Puede recibir solicitudes automáticamente de el area del cliente de DO',
    presets: [],
    group: PROCESS,
    order: 26,
  },
  CAN_RESET_PASSWORD: {
    value: 'can_reset_password',
    text: 'Puede reiniciar contraseña',
    presets: [],
    group: USERS,
    order: 1,
  },
  CAN_CREATE_LOAN_APPLICATION_FROM_CRM: {
    value: 'can_create_loan_application_from_crm',
    text: 'Puede crear solicitudes desde el crm',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
    ],
    group: PROCESS,
    order: 12,
  },
  CAN_UPDATE_BROKER_REFERENCE_CODE: {
    value: 'can_update_broker_reference_code',
    text: 'puede editar el código de referente del corredor',
    presets: [],
    group: PROCESS,
    order: 12,
  },
  CAN_READ_P2P_LOAN_APPLICATIONS: {
    value: 'can_read_p2p_loan_applications',
    text: 'puede ver solicitudes P2P',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
  },
  CAN_READ_INCREASING_QUOTA_SOLUTION_LOAN_APPLICATIONS: {
    value: 'can_read_increasing_quota_solution_loan_applications',
    text: 'Puede ver solicitudes Solución Cuota Creciente',
    presets: [
      ASESOR_PRESET,
      MANAGER_PRESET,
      DIRECTOR_PRESET,
      SUBDIRECTOR_PRESET,
      COMPLIANCE_PRESET,
    ],
    group: PROCESS,
    order: 27,
  },
  CAN_EDIT_AGENTS: {
    value: 'can_edit_agents',
    text: 'Puede editar agentes',
    presets: [],
    group: USERS,
  },
};

const PermissionsKeys = Object.keys(Permissions);

export const PermissionsArray = PermissionsKeys.map(p => Permissions[p]);

export const PermissionsEnum = PermissionsKeys.reduce((acc, current) => {
  acc[current] = Permissions[current].value;
  return acc;
}, {});

// export const PermissionsOptions = PermissionsArray;

export const AsesorPresetPermissions = PermissionsArray.filter(p =>
  p.presets.includes(ASESOR_PRESET)
);

export const ManagerPresetPermissions = PermissionsArray.filter(p =>
  p.presets.includes(MANAGER_PRESET)
);

export const DirectorPresetPermissions = PermissionsArray.filter(p =>
  p.presets.includes(DIRECTOR_PRESET)
);

export const SubdirectorPresetPermissions = PermissionsArray.filter(p =>
  p.presets.includes(SUBDIRECTOR_PRESET)
);

export const CompliancePresetPermissions = PermissionsArray.filter(p =>
  p.presets.includes(COMPLIANCE_PRESET)
);

const {
  CAN_READ_HOME_LOAN_APPLICATIONS,
  CAN_READ_NOT_CLASSIFIED_APPLICATIONS,
} = PermissionsEnum;
/**
 * This permissions are used for navigation authorization and route based authorization.
 */
export const loanApplicationsPermissions = [
  CAN_READ_HOME_LOAN_APPLICATIONS,
  CAN_READ_NOT_CLASSIFIED_APPLICATIONS,
];

export default Permissions;



// WEBPACK FOOTER //
// ./src/utils/constants/Permissions.js